package fr.manyverse.app.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class TableMember(
    @SerialName("id")
    val id: String,

    @SerialName("table_id")
    val tableId: String,

    @SerialName("user_id")
    val userId: String,

    @SerialName("character_id")
    val characterId: String?,

    @SerialName("role")
    val role: MemberRole,

    @SerialName("joined_at")
    val joinedAt: Instant
)
